{
	"tabs": {
		"label": "Food & Beverages sections",
		"overview": "Overview",
		"scan": "Scan meal pass",
		"halls": "Dining halls",
		"orders": "Takeaway orders",
		"toConfirm_one": "{{n}} order to confirm",
		"toConfirm_other": "{{n}} orders to confirm"
	},
	"common": {
		"cancel": "Cancel",
		"loading": "Loading…",
		"loadFailed": "Couldn't load this",
		"tryAgain": "Try again"
	},
	"meal": {
		"BREAKFAST": "Breakfast",
		"LUNCH": "Lunch",
		"DINNER": "Dinner"
	},
	"diet": {
		"HALAL": "Halal",
		"VEGETARIAN": "Vegetarian",
		"VEGAN": "Vegan",
		"NO_BEEF": "No beef",
		"NO_PORK": "No pork",
		"GLUTEN_FREE": "Gluten-free",
		"LACTOSE_FREE": "Lactose-free",
		"NUT_ALLERGY": "Nut allergy",
		"withCount": "{{diet}} {{n}}"
	},
	"time": {
		"range": "{{from}}–{{to}}",
		"zoneNote": "Hall hours and pick-up times are {{zone}}, the Games' local time."
	},
	"status": {
		"label": {
			"PENDING": "Pending",
			"CONFIRMED": "Confirmed",
			"REJECTED": "Rejected",
			"CANCELLED": "Cancelled",
			"COLLECTED": "Collected"
		},
		"hint": {
			"PENDING": "Waiting for the host to confirm",
			"CONFIRMED": "The kitchen packs it",
			"REJECTED": "The host turned it down — see the reason",
			"CANCELLED": "Called off — see the reason",
			"COLLECTED": "Picked up by the team"
		}
	},
	"guide": {
		"title": "Takeaway order statuses",
		"statuses": "Statuses",
		"markers": "Markers"
	},
	"overview": {
		"tiles": {
			"aria": "Meals on the day",
			"expected": "Expected",
			"expectedNote": "dine-in meals on {{day}}",
			"served": "Served",
			"servedNote": "{{pct}}% of expected so far",
			"notStarted": "not started",
			"takeaway": "Takeaway",
			"takeawayNote": "confirmed packs",
			"toConfirm": "Orders to confirm",
			"review": "Review",
			"none": "none",
			"over": "Over capacity",
			"overNote_one": "meal session",
			"overNote_other": "meal sessions",
			"allFit": "all fit the seats"
		}
	},
	"plan": {
		"title": "Meals by hall",
		"definition": "Expected = people staying in the buildings a hall serves, on site for the meal, whose card includes meals, minus takeaway packs. All Games kitchens are halal; only special diets are counted.",
		"hall": "Hall",
		"diets": "Special diets",
		"hallLine": "{{cluster}} · {{seats}} seats · {{buildings}}",
		"noBuilding": "no building linked",
		"noDiets": "None",
		"none": "No dining halls yet",
		"addHall": "Add a dining hall",
		"ofExpected": "/ {{n}}",
		"servedOf": "{{served}} of {{expected}} served",
		"state": {
			"DONE": "Served",
			"OPEN": "Serving now",
			"LATER": "Later"
		},
		"takeaway_one": "{{n}} takeaway",
		"takeaway_other": "{{n}} takeaway",
		"overCapacity": "{{n}} per {{minutes}} min, {{seats}} seats",
		"dietServed": "Served here",
		"dietMissing": "Not on this hall's menu"
	},
	"attention": {
		"title": "Needs attention",
		"clear": "All clear",
		"clearHint": "Nothing waits on the F&B desk right now.",
		"review": "Review",
		"halls": "Halls",
		"edit": "Edit",
		"orders": {
			"title_one": "{{n}} takeaway order to confirm",
			"title_other": "{{n}} takeaway orders to confirm",
			"hint_one": "Orders less than {{count}} hour before the meal are marked late.",
			"hint_other": "Orders less than {{count}} hours before the meal are marked late."
		},
		"over": {
			"title_one": "{{n}} meal session is over seating",
			"title_other": "{{n}} meal sessions are over seating",
			"hint": "{{list}}. Extend the session or open overflow seating.",
			"item": "{{hall}} ({{meal}})"
		},
		"diets": {
			"title_one": "{{n}} special diet is not on a hall's menu",
			"title_other": "{{n}} special diets are not on a hall's menu",
			"hint": "Diners need it but the hall does not serve it: {{list}}. Edit the hall.",
			"item": "{{diet}} at {{hall}} ({{n}})"
		},
		"noHall": {
			"title_one": "{{n}} building with guests has no dining hall",
			"title_other": "{{n}} buildings with guests have no dining hall",
			"hint": "{{list}}. Their guests are not counted anywhere until a hall serves the building.",
			"item": "{{building}} ({{n}})"
		},
		"noMeals": {
			"title_one": "{{n}} person in house has no meals on their card",
			"title_other": "{{n}} people in house have no meals on their card",
			"hint": "Extra officials and executives pay at the hall. Expect questions at the door."
		}
	},
	"scan": {
		"open": "Scan meal pass",
		"title": "Scan meal pass",
		"sub": "Checks the meal entitlement on the AC card",
		"hall": "Dining hall",
		"chooseHall": "Choose the dining hall",
		"noHalls": "No open dining hall yet. Add one under Dining halls.",
		"input": "Card number or QR code",
		"placeholder": "Scan the QR or type the card number",
		"inputHint": "A QR reader types the code and presses Enter for you.",
		"check": "Check",
		"ok": "Enjoy your meal · {{name}}",
		"refused": "Not allowed · {{name}}",
		"mealDiets": "{{meal}} · {{diets}}",
		"noDiet": "No special diet",
		"who": "{{org}} · {{category}} · Card {{card}}",
		"usuallyEats": "Usually eats at {{hall}}",
		"noHomeHall": "No home hall: not staying in a building a hall serves",
		"photoOf": "Photo of {{name}}",
		"noPhoto": "No photo",
		"notFound": "No card found",
		"notFoundHint": "Nothing matches “{{typed}}”. Check the number, or send them to the accreditation desk.",
		"reason": {
			"CARD_NOT_ACTIVE": "The card is not active. Send them to the accreditation desk.",
			"NO_MEAL_ACCESS": "This card does not include meals.",
			"HALL_NOT_SERVING": "{{hall}} is not serving now.",
			"ALREADY_SERVED": "Already served this meal today.",
			"ALREADY_SERVED_at": "Already had {{meal}} today at {{hall}}, {{time}}.",
			"NOT_FOR_THIS_HALL": "This hall is only for some NOCs or categories, and this card is not one of them."
		},
		"reasonShort": {
			"CARD_NOT_ACTIVE": "Card not active",
			"NO_MEAL_ACCESS": "No meals on card",
			"HALL_NOT_SERVING": "Hall not serving",
			"ALREADY_SERVED": "Already served",
			"NOT_FOR_THIS_HALL": "Not for this hall"
		},
		"outcome": {
			"OK": "Allowed",
			"REFUSED": "Refused"
		},
		"recent": "Recent scans",
		"todayCount_one": "{{n}} today",
		"todayCount_other": "{{n}} today",
		"noneYet": "No scans at this hall today."
	},
	"halls": {
		"title": "Dining halls",
		"count_one": "{{n}} hall",
		"count_other": "{{n}} halls",
		"add": "Add dining hall",
		"edit": "Edit {{name}}",
		"line": "{{cluster}} · {{seats}} seats",
		"inactive": "Closed",
		"noBuilding": "No building linked",
		"noDiets": "No special diets",
		"empty": "No dining halls yet",
		"emptyHint": "Add the halls where people eat, with their hours and the buildings they serve.",
		"settingsLine": "Takeaway orders less than {{hours}} h before the meal are marked late · a seat turns over every {{minutes}} min.",
		"openToAll": "Open to everyone",
		"onlyFor": "Only for"
	},
	"hallForm": {
		"addTitle": "Add dining hall",
		"addSub": "Complete the dining hall information",
		"editTitle": "Edit dining hall",
		"save": "Save dining hall",
		"saved": "Saved · {{name}}",
		"sections": {
			"hall": "Hall",
			"buildings": "Buildings",
			"timetable": "Meal timetable",
			"diets": "Special diets",
			"who": "Who can eat here"
		},
		"cluster": "Cluster",
		"name": "Dining hall name",
		"address": "Address",
		"phone": "Contact number",
		"seats": "Seats",
		"seatsHint_one": "A seat turns over about every {{count}} minute.",
		"seatsHint_other": "A seat turns over about every {{count}} minutes.",
		"active": "Open",
		"activeHint": "A closed hall leaves the scan station and new orders. Halls are never deleted once used.",
		"buildings": "Serves these buildings",
		"buildingsHint": "Each building eats at one hall. Its guests count towards this hall's expected meals.",
		"chooseClusterFirst": "Choose a cluster first.",
		"noBuildings": "No lodging building in this cluster yet.",
		"buildingsFailed": "Couldn't load the buildings: {{message}}",
		"servedBy": "{{building}} · served by {{hall}}",
		"buildingInactive": "Inactive",
		"timetableHint": "One timetable for every day, in {{zone}} (the Games' local time). No overnight sessions.",
		"starts": "{{meal}} starts",
		"ends": "{{meal}} ends",
		"to": "to",
		"sessionError": "{{meal}}: {{message}}",
		"diets": "Special diets served",
		"dietsHint": "Every meal is halal.",
		"errors": {
			"cluster": "Choose a cluster",
			"address": "Address is required",
			"nameTaken": "A dining hall with this name already exists"
		},
		"who": "Who can eat here",
		"whoOpen": "Everyone (the default)",
		"whoLimited": "Only some NOCs or categories",
		"whoOpenHint": "Anyone with meals on their card can eat here.",
		"whoLimitedHint": "A card must be from a ticked NOC (any NOC if none is ticked) and of a ticked category (any category if none is ticked).",
		"whoNocs": "NOCs",
		"whoCategories": "Categories"
	},
	"settings": {
		"open": "Settings",
		"title": "F&B settings",
		"sub": "For every dining hall of these Games",
		"cutoff": "Takeaway cut-off (hours)",
		"cutoffHint": "Orders placed less than this before the meal are marked late. They are never blocked.",
		"turn": "Seat turn (minutes)",
		"turnHint": "How long one seating takes. A session is over capacity when it seats more per turn than the hall has seats.",
		"range": "A whole number from {{min}} to {{max}}",
		"save": "Save settings",
		"saved": "Settings saved"
	},
	"orders": {
		"title": "Takeaway orders",
		"count_one": "{{n}} order",
		"count_other": "{{n}} orders",
		"new": "New order",
		"search": "Order or contingent",
		"filters": "Filters",
		"filtersCount": "Filters ({{n}})",
		"filtersApply": "Apply filters",
		"filtersClear": "Clear",
		"filter": {
			"hall": "Dining hall",
			"date": "Date",
			"all": "All"
		},
		"sort": {
			"meal_time": "Meal time",
			"recent": "Recently ordered",
			"packs": "Most packs"
		},
		"chips": {
			"status": "Status"
		},
		"late": "Late",
		"lateTag": "late",
		"lateHint_one": "Ordered less than {{count}} hour before the meal",
		"lateHint_other": "Ordered less than {{count}} hours before the meal",
		"standardOnly": "Standard only",
		"note": "Note: {{note}}",
		"table": {
			"status": "Status / Order",
			"meal": "Meal",
			"pickup": "Pick-up ({{zone}})",
			"contingent": "Contingent",
			"packs": "Packs",
			"diets": "Special diets",
			"reason": "Reason",
			"ordered": "Ordered"
		},
		"pager": {
			"showing_one": "Showing {{from}} to {{to}} of {{total}} order",
			"showing_other": "Showing {{from}} to {{to}} of {{total}} orders",
			"showingNoTotal": "Showing {{from}} to {{to}}",
			"empty": "No orders"
		},
		"empty": {
			"none": "No takeaway orders yet",
			"noneHint": "Teams order packed meals when a match or training clashes with the hall's hours.",
			"filteredTitle": "No orders match",
			"filteredHint": "Try another search or clear the filters.",
			"clear": "Clear filters"
		}
	},
	"bulk": {
		"selected_one": "{{n}} selected",
		"selected_other": "{{n}} selected",
		"toConfirm_one": "{{n}} to confirm",
		"toConfirm_other": "{{n}} to confirm",
		"more": "More",
		"confirmN": "Confirm {{n}}",
		"clear": "Clear selection",
		"tooMany": "Pick at most {{max}} orders at a time",
		"moreTitle": "Change status",
		"xOfN": "{{x}} of {{n}}",
		"action": {
			"CONFIRMED": "Confirm",
			"COLLECTED": "Mark collected",
			"REJECTED": "Reject",
			"CANCELLED": "Cancel"
		},
		"actionHint": {
			"CONFIRMED": "The kitchen packs it",
			"COLLECTED": "Picked up by the team",
			"REJECTED": "Needs a reason",
			"CANCELLED": "Needs a reason"
		},
		"confirmTitle": {
			"CONFIRMED_one": "Confirm {{n}} order",
			"CONFIRMED_other": "Confirm {{n}} orders",
			"COLLECTED_one": "Mark {{n}} order collected",
			"COLLECTED_other": "Mark {{n}} orders collected",
			"REJECTED_one": "Reject {{n}} order",
			"REJECTED_other": "Reject {{n}} orders",
			"CANCELLED_one": "Cancel {{n}} order",
			"CANCELLED_other": "Cancel {{n}} orders"
		},
		"verb": {
			"CONFIRMED": "Confirm {{n}}",
			"COLLECTED": "Mark {{n}} collected",
			"REJECTED": "Reject {{n}}",
			"CANCELLED": "Cancel {{n}}"
		},
		"packs_one": "{{n}} pack",
		"packs_other": "{{n}} packs",
		"lateNote_one": "{{n}} order was placed less than {{hours}} hours before the meal. Check with the kitchen first.",
		"lateNote_other": "{{n}} orders were placed less than {{hours}} hours before the meal. Check with the kitchen first.",
		"leftOut_one": "{{n}} order is left out",
		"leftOut_other": "{{n}} orders are left out",
		"leftItem": "{{ref}} · already {{status}}",
		"reason": "Reason",
		"reasonHint": "The contingent sees this.",
		"back": "Back",
		"failed": "Couldn't change the orders",
		"done": {
			"CONFIRMED_one": "{{n}} order confirmed",
			"CONFIRMED_other": "{{n}} orders confirmed",
			"COLLECTED_one": "{{n}} order marked collected",
			"COLLECTED_other": "{{n}} orders marked collected",
			"REJECTED_one": "{{n}} order rejected",
			"REJECTED_other": "{{n}} orders rejected",
			"CANCELLED_one": "{{n}} order cancelled",
			"CANCELLED_other": "{{n}} orders cancelled"
		},
		"skippedToast_one": "{{n}} order was left alone: {{list}}",
		"skippedToast_other": "{{n}} orders were left alone: {{list}}",
		"skipItem": "{{ref}} ({{reason}})",
		"skipReason": {
			"not_found": "not found",
			"forbidden": "not allowed",
			"invalid_transition": "its status changed",
			"meal_started": "the meal has started",
			"changed": "changed meanwhile, try again"
		}
	},
	"orderForm": {
		"hostTitle": "New takeaway order",
		"hostSub": "Entered by the host for a contingent. It is confirmed at once.",
		"nocTitle": "Order packed meals",
		"nocSub_one": "The host confirms. Order at least {{count}} hour before the meal.",
		"nocSub_other": "The host confirms. Order at least {{count}} hours before the meal.",
		"contingent": "Contingent",
		"hall": "Dining hall",
		"yours": "{{name}} (yours)",
		"choose": "Choose",
		"date": "Date",
		"meal": "Meal",
		"packs": "Total packs",
		"packsHint": "1 to {{max}}",
		"pickup": "Pick-up time",
		"pickupHint": "The hall serves this meal {{from}}–{{to}}.",
		"diets": "Of which special diets",
		"reason": "Reason",
		"why": "Why packed?",
		"reasonPlaceholder": "Competition during lunch",
		"lateNote_one": "Less than {{count}} hour before the meal: the order will be marked late.",
		"lateNote_other": "Less than {{count}} hours before the meal: the order will be marked late.",
		"startedNoc": "This meal has already started. Choose a later meal or contact the F&B desk.",
		"startedHost": "This meal has already started.",
		"create": "Create order",
		"send": "Send to the host",
		"created": "Order {{ref}} created",
		"createdLate_one": "Order {{ref}} sent — less than {{count}} hour ahead, so it is marked late",
		"createdLate_other": "Order {{ref}} sent — less than {{count}} hours ahead, so it is marked late",
		"errors": {
			"org": "Choose the contingent",
			"hall": "Choose the dining hall",
			"date": "Choose the date"
		}
	},
	"noc": {
		"strip": {
			"aria": "Your packed meal orders",
			"orders": "Orders",
			"waiting": "Waiting for the host",
			"confirmed": "Confirmed",
			"rejected": "Rejected",
			"seeReason": "see the reason below",
			"none": "none"
		},
		"eats": "Where your delegation eats",
		"noHall": "No dining hall yet",
		"noHallHint": "It is set when the host assigns your rooms.",
		"bringCard": "Bring your AC card. All meals are halal.",
		"bringCardDiets": "Bring your AC card. All meals are halal; also {{diets}}.",
		"buildingPeople_one": "{{building}}: {{n}} of yours",
		"buildingPeople_other": "{{building}}: {{n}} of yours",
		"packed": "Packed meals",
		"order": "Order packed meals",
		"orderTitle_one": "{{n}} pack · {{meal}}, {{day}}",
		"orderTitle_other": "{{n}} packs · {{meal}}, {{day}}",
		"orderLine": "{{ref}} · pick up {{time}} at {{hall}}",
		"orderedLate": "ordered late",
		"standardPacks": "Standard packs",
		"hostNote": "Host: {{note}}",
		"empty": "No packed meals ordered",
		"emptyHint": "Order packed meals when a match or training clashes with the hall's hours.",
		"cancel": "Cancel",
		"cancelTitle": "Cancel this order",
		"cancelSub": "{{ref}} · the kitchen will not pack it",
		"cancelConfirm": "Cancel order",
		"back": "Back",
		"reasonPlaceholder": "The host sees this",
		"cancelled": "Order {{ref}} cancelled"
	},
	"formMessages": {
		"required": "Required",
		"textTooLong": "Too long",
		"invalidTime": "Use HH:MM",
		"sessionsAllMeals": "Set breakfast, lunch and dinner",
		"sessionEndsAfterStart": "The end time must be after the start time",
		"duplicateDiet": "Each diet once",
		"duplicateBuilding": "Each building once",
		"seatsRange": "Seats must be a whole number from {{min}} to {{max}}",
		"packsRange": "A whole number from 1 to {{max}}",
		"dietPacksOver": "The special-diet packs add up to more than the total",
		"noteRequired": "Give a reason",
		"scanTarget": "Scan a card or type its number",
		"nothingToChange": "Nothing to change",
		"duplicateId": "Each order once",
		"duplicateChoice": "Each one once"
	}
}
